import { Breadcrumbs, Link } from '@material-ui/core';
import { House } from '@material-ui/icons';
import { VideoFileCollectionItemT, ViewClientT } from 'bovaljaren-models';
import { useObserver } from 'mobx-react-lite';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { ObosHouse } from '../../../icons/obos/obosIcons';
import BrandingService from '../../../services/branding.service';
import { AppContext } from '../../../state/app.state';
import { isMobile } from '../../../utils/app.helper';

import './NavBreadCrumbs.scss';

type NavBredCrumbsProps={
    className?: string;
    id?: string;
};

const NavBreadCrumbs: React.FC<NavBredCrumbsProps> = ({ children, className, id }): ReactElement => {
    const { state, presentationState } = useContext(AppContext);
    const [mainView, setMainView] = useState<ViewClientT>();

    useEffect(() => {
        setMainView(state?.project?.views.find(v => v.id === state.project?.primaryViewId));
    }, [state?.project?.primaryViewId, state?.project?.views]);

    return useObserver(() => (
        <><div className='top-left'>
            {state?.project?.views && state?.project?.views?.length > 1 && (isMobile() ? !presentationState?.showObjectView : true) && <div className='bv-bcrumb' onMouseLeave={(): void => {
                !isMobile() && setTimeout(() => presentationState && presentationState.setExpandNavBreadcrumbs(false), 400);
            }}>
                <Breadcrumbs aria-label="breadcrumb" separator='' className='bv-bcrumb-wrapper' onClick={(e) => presentationState && presentationState.setExpandNavBreadcrumbs(true)}>
                    {BrandingService.check(['obos']) &&
                        <ObosHouse className='bv-bcrumb-house' onClick={() => state?.setCurrentViewId(mainView?.id || null)}/>
                    }
                    {!BrandingService.check(['obos']) &&
                        <House className='bv-bcrumb-house' onClick={() => state?.setCurrentViewId(mainView?.id || null)}/>}
                    <Link underline="hover" style={{ color: 'white' }}>
                        <p style={{ display: BrandingService.check(['obos']) ? 'unset' : 'inline' }} className={'bv-bcrumb-title'}>{state?.currentView?.name || ''}</p>
                    </Link>
                </Breadcrumbs>
                {presentationState?.expandNavBreadcrumbs &&
                    state?.project?.views.filter(v => state.currentView ? v.id !== state.currentView.id : true).map(v =>
                        <Link underline="hover" className={'bv-bvcrumb-sublink'} key={v.id} onClick={() => {
                            isMobile() && presentationState.setExpandNavBreadcrumbs(false);
                            state?.setCurrentViewId(v.id || null);
                        }} style={{ color: 'white' }}>
                            <p>{v.name || ''}</p>
                        </Link>
                    )}
            </div>}
        </div></>
    ));
};


export default NavBreadCrumbs;